import PropTypes from 'prop-types';
import { Address } from 'utils/prop-types';
import { DB_PREFIX } from './constants';

export default PropTypes.shape({
  [DB_PREFIX]: Address,
});
